import React from 'react'
import { Dialog, Pane, Button, CaretRightIcon, Spinner, Text} from 'evergreen-ui'
import { SelectMaterials } from '../Quote/Materials'
import { TypeList } from '../Quote/Materials/TypeList';
import { useAPI } from '../Api';
import { Drawing } from '../Drawing';
import { useCart } from '../Cart';
import { Link } from "react-router-dom";

import { BookOrder } from '../Cart';
import { findMaterial } from '../Quote/Materials/MaterialFuncs'

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { useNavigate } from "react-router-dom";

export default function MultipleItemsDialog(props) {
    const API = useAPI();
    const Cart = useCart();
    const [orders, setOrders] = React.useState([]);
    const [Materials, setMaterials] = React.useState(null);
    const [material, setMaterial] = React.useState(null);
    const [disabled, setDisabled] = React.useState(true);
    const [busy, setBusy] = React.useState(true);

    let navigate = useNavigate();


    // const [bends, setBends] = useState(null);



    // let reFreshMaterial = () => {
    //     setUpdate(true)
    //     API.getMaterial(orders[0]).then((m) => {
    //         if (m) {
    //             setMaterial(findMaterial(m.Materials, material));

    //             let o = orders.map((item)=>{
    //                 item.SetupFee = m.SetupFee;
    //                 console.log(item, "itemmm")
    //                 return item
    //             });
    //             setOrders([...o]);

    //         }
    //         setUpdate(false)
    //     });
    // }


    // React.useEffect(() => {
    //     let o = order;
    //     o.selMaterial = material;
    //     setOrder({ ...o });
    //     console.log("Material Selected...", material)
    // }, [material])

    let reFreshMatList = async () => {
        if (orders.length <=0 ) return;
        const m = await API.getAllMaterials(orders[0]);
        if (m)
            setMaterials([...m]);
    }

    React.useEffect(() => {
        let o = orders.map((item) => {
            item.selMaterial = material;
            item.bulkOrderWarning = true;
            return item;
        });
        setOrders([...o]);
        setDisabled(false)
    }, [material])

    React.useEffect(() => {
        setOrders(props.selected.map(v => new BookOrder(v)));
        setDisabled(true)
        setBusy(false);
    }, [])

    React.useEffect(() => {
        if (!Materials)
            reFreshMatList()
    }, [orders])

    const addToCart = async () => {
        setBusy(true)
        
        for (let index = 0; index < orders.length; index++) {
            const o = orders[index];
            let totals = o.drawing.calcContour()

            o.cuts = totals.Cuts.qty;
            o.cuttingLength = totals.Cuts.totallen;
            let a = API.getMaterial(o)
            const m = await a
            o.selMaterial = findMaterial(m.Materials, o.selMaterial);
            o.RawSetupFee = m.SetupFee;

        }
        Cart.add(orders);
     
        navigate('/cart');
          
    }

    // console.log("ORDERS: ", orders)

    return (
        <Dialog
            width={"100%"}
            height={"100%"}
            isShown={true}
            title={busy?"Please Wait":"Please select the material"}
            onCloseComplete={() => props.setIsShown(false)}
            hasFooter={false}
            shouldCloseOnOverlayClick={false}
        >
            {busy && <Pane display={"flex"} justifyContent={"center"} alignItems={"center"} height={"200px"} flexDirection="column">
                {/* <img src={spinner} width={"100px"} className={"rotate"} /> */}
                <Spinner size={50}/>
                <Text><strong>Loading Items...</strong></Text>
            </Pane>}
            {busy === false && <><Pane display={"flex"} justifyContent="center" alignItems="center" flexDirection="row" width={"100%"} gap={"10px"}>
                <Pane width={"40%"}>
                    <Carousel width={"100%"} style={{ outline: 'none' }} emulateTouch={true} showArrows={true} showThumbs={false}>
                        {orders.map(order => {
                            // console.log("start: ", order)
                            // return  <div style={{width: "250px", height: "250px"}} dangerouslySetInnerHTML={{ __html: order.book.svg }} />
                            return order.book && <Drawing heading={order.book.display} drawing={order.drawing} Width={400} Height={400} />
                        })}
                    </Carousel>
                </Pane>
                <Pane width={"60%"}>
                    <SelectMaterials order={orders[0]} setOrder={(e) => {

                    }} Materials={Materials} material={material} setMaterial={setMaterial}></SelectMaterials>
                </Pane>
            </Pane>
                <Pane bottom="0" right="0" display="flex" justifyContent="flex-end">
                   
                        <Button
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            flexDirection="row"
                            gap="5px"
                            appearance="primary"
                            disabled={disabled}
                            onClick={() => { addToCart() }}
                        >
                            Add to Cart <CaretRightIcon size={20} />
                        </Button>
                  
                </Pane>
            </>}
        </Dialog>
    )
}
